<template>
    <div class="dineDrink">
        <page-cover
            v-if="DrinkDinePage.PageCover"
            :img="DrinkDinePage.PageCover.Image?.url ?? ''"
            :title="DrinkDinePage.PageCover.Title"
            :sub-title="DrinkDinePage.PageCover.Subtitle"
        />
        <section v-if="DrinkDinePage.Stores">
            <div
                class="md:container mx-auto px-4 lg:px-12 py-8 md:py-12 lg:py-24"
            >
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-16"
                >
                    {{ DrinkDinePage.Stores.Title }}
                </h3>
                <div
                    class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 md:gap-6"
                >
                    <storesPageCard
                        v-for="(storeCard, index) in DrinkDinePage.Stores
                            .stores"
                        :key="index"
                        :title="storeCard.Name"
                        :logo-url="storeCard.LogoUrl?.url ?? ''"
                        :nav-to="`/stores/${storeCard.slug}`"
                    />
                </div>
            </div>
        </section>
        <section v-if="DrinkDinePage.Offers" class="section-bg">
            <div class="px-4 py-8 md:px-12 md:py-12 lg:py-24">
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-8 md:mb-16"
                >
                    {{ DrinkDinePage.Offers.Title }}
                </h3>
                <div
                    class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12"
                >
                    <OfferPageCard
                        v-for="(offer, index) in DrinkDinePage.Offers.offers"
                        :key="index"
                        :title="offer.Title"
                        :image="offer.Poster?.url ?? ''"
                        :expiry="checkExpiry(offer.ExpiresOn)"
                        :nav-to="`/offers/${offer.Slug}`"
                    />
                </div>
            </div>
        </section>
        <section
            v-if="
                DrinkDinePage.RelatedNewsEvents &&
                DrinkDinePage.RelatedNewsEvents.news_events &&
                DrinkDinePage.RelatedNewsEvents.news_events.length
            "
        >
            <div class="px-4 py-8 md:px-12 md:py-12 lg:py-24">
                <h3
                    class="text-2xl md:text-5xl text-primary text-center font-semibold tracking-wide mb-16"
                >
                    {{ DrinkDinePage.RelatedNewsEvents.Title }}
                </h3>
                <masonry-layout
                    :data-items="DrinkDinePage.RelatedNewsEvents.news_events"
                />
            </div>
        </section>
    </div>
</template>

<script setup>
import dayjs from 'dayjs';
const config = useRuntimeConfig();
const { data: DrinkDinePage } = await useFetch(
    config.public.baseURl + '/drink-and-dine-page'
);
function checkExpiry(exp) {
    return exp
        ? dayjs(dayjs(exp)).diff(new Date(), 'day') < 10
            ? `Expires on ${dayjs(exp).format('DD/MM/YYYY')}`
            : 'On Going'
        : '';
}
useHead({
    title: 'Dine & Drink',
});
</script>

<style lang="scss" scoped>
.dineDrink {
}
</style>
